import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { Title } from "../../../../../../themes/Default/components/Title";
import { Wizard } from "../../../../../../themes/Default/components/Wizard";
import { Step } from "../../../../../../themes/Default/components/Wizard/Step";
import { groupProgressManagement } from "../../../../../../hooks/api/GroupProgressManagement/GroupProgressManagement";

const EditProgress = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const [formErrors, setFormErrors] = useState([]);
    const { useViewGroupProgressMutation, useUpdateGroupProgressMutation } = groupProgressManagement;
    const [viewGroupProgress] = useViewGroupProgressMutation();
    const [updateGroupProgress] = useUpdateGroupProgressMutation();
    const { groupProgressId } = useParams();

    const tabs = [
        { title: t("plans.title"), onClick: () => gotoPlansTab() },
        { title: t("groupTypes.title"), onClick: () => gotoTypeTab() },
        { title: t("groups.progress"), isActive: true },
        { title: t("groups.progressTest"), onClick: () => gotoProgressTestTab() },
    ];

    const gotoTypeTab = () => {
        navigate("/settings/groups/types");
    };

    const gotoPlansTab = () => {
        navigate("/settings/groups/plans");
    };
    
    const gotoProgressTestTab = () => {
        navigate("/settings/groups/progress-tests");
    };

    const gotoProgressTypeStep = (values) => {
        navigate('/settings/groups/progress/'+groupProgressId+'/type/add');
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateGroupProgress({body, settingsGroupProgressId: groupProgressId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                toast.info(result.data.info.responseMessage);
            }
        });
    };


    useEffect(() => {
        viewGroupProgress(groupProgressId).then((result) => {
            formRef.current.setValues(result?.data);
            
        });
    }, []);


    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/groups/progress" />
                <Button title={t('save')} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{t('Napredak')}</Title>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("groups.title")} />
                    <Link title={t("Napredak")} />
                    <Link title={t('details')} isActive={true}/>
                </Breadcrumps>
                <br/>
                <br/>
                <br/>
                <Wizard>
                    <Step title={t('Naziv kolone')} isActive={true} />
                    <Step title={t('Odabir tipova grupa')} isChecked={true} onClick={gotoProgressTypeStep} />
                    <Step title={t('Dodavanje vrednosti')} isChecked={true}  />
                </Wizard>
                <br/>
                <br/>
                <br/>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        name: "",
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Input 
                                        name="name" 
                                        label={t('Opis vestine')} 
                                        value={values.name} 
                                        onChange={handleChange} 
                                        required={true} 
                                        error={formErrors?.name}
                                    />
                                </Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditProgress;
